import React from 'react';
import {Switch, Route, Redirect, Router} from 'react-router-dom';
import AuthContainer from '../containers/AuthContainer';
import MainContainer from '../containers/MainContainer';
import {rootMainPath, rootAuthPath, errorPath, noFoundPath, policyPath, providersPath} from './paths';
import {ErrorPage, NotFound} from '../features/Components/Error';
import {history} from '../redux/store/store';
import PrivacyPolicy from '../features/PrivacyPolicy';
import Facebook from '../features/Auth/Providers/Facebook/Facebook';
import Google from '../features/Auth/Providers/Google/Google';
import {ToastContainer} from "react-toastify";

const AppRoutes = () => {
  return (
    <>
      <Router history={history}>
        <Switch>
          <Route
            path='/'
            exact
            render={() => (localStorage.token ? <Redirect to={rootMainPath} /> : <Redirect to={rootAuthPath} />)}
          />
          <Route path={rootAuthPath} component={AuthContainer} />
          <Route path={rootMainPath} component={MainContainer} />
          <Route path={providersPath.facebook} component={Facebook} />
          <Route path={providersPath.google} component={Google} />
          <Route path={errorPath} component={ErrorPage} />
          <Route path={noFoundPath} component={NotFound} />
          <Route path={policyPath} component={PrivacyPolicy} />
          <Route path={'*'} render={() => <Redirect to={noFoundPath} />} />
        </Switch>
        <ToastContainer/>
      </Router>
    </>
  );
};

export default AppRoutes;
